import { Controller } from "@hotwired/stimulus"
import {useMutation} from "stimulus-use";

export default class extends Controller {

  connect() {
    this.isInitialized = false;

    useMutation(this, { attributes: false, childList: true, subtree: true })
    this.count(this.element.dataset.state, this.element.dataset.type);

    this.isInitialized = true;
  }

  count(state, type) {
    let header_class_name;
    if (document.querySelectorAll('.grid-header').length > 0) {
      header_class_name = "grid-header";
    } else {
      header_class_name = "kanban-column";
    }

    let boards = document.querySelectorAll(".kanban-board");
    Array.from(boards).forEach((board) => {
      let headers = board.querySelectorAll('.' + header_class_name);
      let size = board.querySelectorAll('.kanban-column-items:has(*)[data-state="' + state + '"][data-type="' + type + '"] .kanban-item').length;

      const selector = `.${header_class_name}[data-state="${state}"][data-type="${type}"]`;
      const header = board.querySelector(selector);

      if (header) {
        const countElem = header.querySelector('.kanban-column-count');
        const isZero = size === 0;
        const hasOpenedClass = header.classList.contains("opened")

        if (isZero && !hasOpenedClass) {
          header.classList.add("collapsed");
        } else if (this.isInitialized) {
          header.classList.remove("collapsed");
        }

        if (countElem) {
          countElem.innerText = isZero ? "" : size;
          countElem.classList.toggle("hidden", isZero);
        }

        if (!isZero) {
          board.querySelectorAll(`.kanban-column-items[data-state="${state}"] .kanban-item`)
            .forEach(elem => elem.classList.remove("hidden"));
        }
      }


      if (header_class_name === "grid-header"){
        let widths = Array.from(headers).map((header) => {
          if (header.classList.contains("collapsed")) {
            return '80px';
          } else {
            return '1fr';
          }
        })

       board.style.setProperty("grid-template-columns", widths.join(" "));
      }
    })

  }

  mutate(entries) {
    for (const mutation of entries) {
      if (mutation.type === 'childList') {
        this.count(this.element.dataset.state, this.element.dataset.type);
      }
    }
  }


}
